import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 20 21.837",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21.837\" id=\"icon-check\"><path d=\"M4.442 13.093v1.953h4.465v-1.953zm4.465 4.163H4.442v1.211H2.07V6.744h6.837V4.837h2.419v1.907h6.907v11.651h-2.372v-1.139h-4.535v4.581H8.907zm2.419-2.209h4.535v-1.954h-4.535zm4.535-4.07v-2h-4.535v2zm-6.954-2H4.442v2h4.465zM20 1.744v4.512h-2.372v-2.3H2.372v2.419H0V1.747h8.628q-.275-.675-.6-1.326l2.581-.419q.279.767.558 1.744z\" fill=\"#1672fa\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol